import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import Dropdown from '~/components/CasesDropdown.vue';
import WebpPicture from '~/components/WebpPicture.vue';
export default {
  __name: 'HelpCases',
  setup: function setup(__props) {
    var timeStore = useTimeStore();
    var appStore = useAppStore();
    var _useNuxtApp = useNuxtApp(),
      $i18n = _useNuxtApp.$i18n,
      $cookieStore = _useNuxtApp.$cookieStore;
    var isLearning = computed(function () {
      return appStore.helpMenu == 'learning';
    });
    var isUkrainianSpeaker = computed(function () {
      var languages = $cookieStore.contentLocale.split('.');
      return languages.includes('uk');
    });
    var copyToClipboabd = useCopyToClipboard;
    var wdFormatter = new Intl.DateTimeFormat("en-US", {
      weekday: "short",
      timeZone: "Europe/Kiev"
    });
    var hourFormatter = new Intl.DateTimeFormat("en-US", {
      hour: "numeric",
      hour12: false,
      timeZone: "Europe/Kiev"
    });
    var WorkHourWeekdays = ["Mon", "Tue", "Wed", "Thu", "Fri"];
    var WorkHourLastWeekday = WorkHourWeekdays[WorkHourWeekdays.length - 1];
    var supportState = computed(function () {
      var wd = wdFormatter.format(timeStore.now);
      var hour = hourFormatter.format(timeStore.now);
      var state = 'active';
      if (WorkHourWeekdays.includes(wd)) {
        // Weekday
        if (hour < 6 || hour >= 24) {
          // 24 is actually 0:00
          state = "night";
        } else if (hour < 10) {
          state = "morning";
        } else if (hour >= 19) {
          if (wd == WorkHourLastWeekday) state = "weekend";else state = "night";
        } else {
          state = "active";
        }
      } else {
        // Weekend
        state = "weekend";
      }
      return state;
    });
    var supportImageSrc = computed(function () {
      var filename = "support-widget-userpic-".concat(supportState.value);
      if (supportState.value == 'weekend') {
        filename = "".concat(filename, "-").concat($i18n.locale);
      }
      return "https://cdn.cases.media/image/original/".concat(filename, ".png");
    });
    var modalityStore = useModalityStore();
    function goBack(event) {
      event.preventDefault();
      event.stopPropagation();
      var name = 'help-root';
      modalityStore.openDropdown({
        name: name
      });
      modalityStore.dropdowns.forEach(function (dd) {
        if (dd.name !== name) modalityStore.closeDropdown({
          name: dd.name
        });
      });
    }
    return {
      __sfc: true,
      timeStore: timeStore,
      appStore: appStore,
      $i18n: $i18n,
      $cookieStore: $cookieStore,
      isLearning: isLearning,
      isUkrainianSpeaker: isUkrainianSpeaker,
      copyToClipboabd: copyToClipboabd,
      wdFormatter: wdFormatter,
      hourFormatter: hourFormatter,
      WorkHourWeekdays: WorkHourWeekdays,
      WorkHourLastWeekday: WorkHourLastWeekday,
      supportState: supportState,
      supportImageSrc: supportImageSrc,
      modalityStore: modalityStore,
      goBack: goBack,
      Dropdown: Dropdown,
      WebpPicture: WebpPicture
    };
  }
};